module.exports = __webpack_public_path__ + "img/icon@2x.9e0b1e70.png";